import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    IonLoading,
    // IonRefresher,
    // IonRefresherContent,
    useIonViewDidLeave,
} from '@ionic/react'
import React, { useState, useRef, useEffect } from 'react'
import Header from '../../components/Header'
import { BotStoreIcon } from '../../conf/images'
import './index.css'
import EmptyMsg from '../../components/EmptyMsg'
import { useHistory } from 'react-router'
import {
    getMyBots,
    updateInstalledBotStatus,
    installStoreBot,
} from '../../service/api/bot'
import BotItem from '../../components/BotItem'
import { BotModel } from '../../model/bot.model'
import { LoadingProps } from '../../model/toast.model'
import {
    BotKnowledgesPage,
    BotStorePage,
    BotDetailPage,
    NewsBotDetailPage,
    BotPushServicePage,
    ScheduleRemindPage,
} from '../../conf/routePath'
import Toast from '../../components/Toast'
let udpateTimer: any = null
const MyBot: React.FC = () => {
    const history = useHistory()
    const [botList, setBotList] = useState<BotModel[]>([])
    const [loadingOptions, setLoadingOptions] = useState<LoadingProps>({
        isOpen: true,
        message: '加载中...',
    })
    const [toast, setToast] = useState({
        isOpen: false,
        message: '',
    })
    const ionRefresher = useRef<any>(null)
    useIonViewDidEnter(() => {
        queryMyBots()
    })
    useIonViewDidLeave(() => {
        udpateTimer && clearTimeout(udpateTimer)
    })
    useEffect(() => {
        return () => {
            udpateTimer && clearTimeout(udpateTimer)
        }
    }, [])
    /** 查询我的机器人 */
    const queryMyBots = async () => {
        try {
            let res = await getMyBots()
            let is_exists_installing_or_deletting =
                res.data.filter(
                    (item) =>
                        item.status === 1 ||
                        item.status === 4 ||
                        item.status === 5
                ).length > 0
            clearTimeout(udpateTimer)
            if (is_exists_installing_or_deletting) {
                udpateTimer = setTimeout(() => {
                    queryMyBots()
                }, 1000)
            } else {
                clearTimeout(udpateTimer)
            }
            if (res.data) {
                setBotList(res.data)
            }
        } catch (error) {}
        setLoadingOptions({
            ...loadingOptions,
            isOpen: false,
        })
        // 上拉加载完毕
        if (ionRefresher !== null && ionRefresher.current !== null) {
            ionRefresher.current.complete()
        }
    }
    /** 更新机器人 */
    const handleBotUpdate = async (botId: string) => {
        try {
            await installStoreBot(botId)
            queryMyBots()
        } catch (error) {
            console.error(error)
            if (error.message) {
                setToast({
                    isOpen: true,
                    message: error.message,
                })
            }
        }
    }
    /** 更新机器人状态 */
    const updateBotStatus = async (bot: BotModel) => {
        try {
            await updateInstalledBotStatus({
                bot_id: bot.id,
                status: 5 - bot.status,
            })
            queryMyBots()
        } catch (error) {}
    }
    return (
        <IonPage className='mybot-page'>
            <IonContent className='mybot-content'>
                <Header title='我的应用'>
                    <img
                        className='bot-store-icon'
                        src={BotStoreIcon}
                        onClick={() => history.push(BotStorePage)}
                        alt='store'
                    />
                </Header>
                {/* <IonRefresher
                    ref={ionRefresher}
                    slot='fixed'
                    onIonRefresh={queryMyBots}
                >
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher> */}
                {botList.map((item) => (
                    <BotItem
                        type='myBot'
                        key={item.id}
                        item={item}
                        onClick={() =>
                            history.push(BotDetailPage, {
                                bot: item,
                            })
                        }
                        onBotUpdate={() => handleBotUpdate(item.id)}
                        onBotConfig={() => {
                            if (item.name === '新闻头条') {
                                history.push(NewsBotDetailPage)
                            } else if (item.name === '消息推送机器人') {
                                history.push(BotPushServicePage)
                            } else if (item.name === '日程提醒') {
                                history.push(ScheduleRemindPage)
                            } else {
                                history.push(BotKnowledgesPage, {
                                    rootTagId: item.appid,
                                    botId: item.id,
                                })
                            }
                        }}
                        onBotSwitch={() => updateBotStatus(item)}
                    />
                ))}
                <IonLoading {...loadingOptions} />
                <Toast />
                <EmptyMsg show={botList.length === 0}>
                    暂无机器人，点击右上角到机器人商店中添加吧!
                </EmptyMsg>
                <Toast
                    {...toast}
                    color='success'
                    position='top'
                    onClose={() => setToast({ ...toast, isOpen: false })}
                />
            </IonContent>
        </IonPage>
    )
}

export default MyBot
